export const menu = [

    // ----------------------------------------------------------------------------------------

    {
        type: 'group',
        name: 'ui-work-group-menu-item',
        label: 'Práce',
        icon: 'screwdriver-wrench',
        parent: null,
        routes: [],
        //        privileges: ['openWork', 'editWork', 'manageWork', 'adminWork']
    },

    {
        type: 'item',
        name: 'ui-work-overview-menu-item',
        label: 'Denní plán činnosti',
        parent: 'ui-work-group-menu-item',
        routes: ['work-overview', 'work-overview-by-day'],
        //privileges: ['manageWork', 'adminWork']
    },
    {
        type: 'item',
        name: 'ui-daily-work-menu-item',
        label: 'Denní výkaz práce',
        parent: 'ui-work-group-menu-item',
        routes: ['daily-work', 'daily-work-by-day', 'daily-work-by-day-and-employee'],
        //privileges: ['editWork', 'manageWork', 'adminWork']
    },
    {
        type: 'item',
        name: 'ui-monthly-work-menu-item',
        label: 'Měsíční výkaz práce',
        parent: 'ui-work-group-menu-item',
        routes: ['monthly-work', 'monthly-work-by-month', 'monthly-work-by-month-and-employee'],
        //privileges: ['editWork', 'manageWork', 'adminWork']
    },

    // ----------------------------------------------------------------------------------------

    {
        type: 'group',
        name: 'ui-machines-group-menu-item',
        label: 'Stroje',
        icon: 'engine',
        parent: null,
        routes: [],
        //privileges: ['openMachines', 'editMachines', 'manageMachines', 'adminMachines'],
    },
    {
        type: 'item',
        name: 'ui-machines-menu-item',
        label: 'Seznam strojů',
        parent: 'ui-machines-group-menu-item',
        routes: ['machine-browser', 'machine-editor'],
        //privileges: ['editMachines', 'manageMachines', 'adminMachines'],
    },

    // ----------------------------------------------------------------------------------------

    {
        type: 'group',
        name: 'ui-customers-group-menu-item',
        label: 'Zákazníci',
        icon: 'user-hat-tie',
        parent: null,
        routes: [],
        //privileges: ['openCustomers', 'editCustomers', 'manageCustomers', 'adminCustomers'],
    },
    {
        type: 'item',
        name: 'ui-customers-menu-item',
        label: 'Seznam zákazníků',
        parent: 'ui-customers-group-menu-item',
        routes: ['customer-browser', 'customer-editor'],
        //privileges: ['editCustomers', 'manageCustomers', 'adminCustomers'],
    },

    // ----------------------------------------------------------------------------------------

    {
        type: 'group',
        name: 'ui-employees-group-menu-item',
        label: 'Zaměstnanci',
        icon: 'user-helmet-safety',
        parent: null,
        routes: [],
        //privileges: ['openEmployees', 'editEmployees', 'manageEmployees', 'adminEmployees'],
    },
    {
        type: 'item',
        name: 'ui-employees-menu-item',
        label: 'Seznam zaměstnanců',
        parent: 'ui-employees-group-menu-item',
        routes: ['employee-browser', 'employee-editor'],
        //privileges: ['editEmployees', 'manageEmployees', 'adminEmployees'],
    },

    // ----------------------------------------------------------------------------------------

    {
        type: 'item',
        name: 'ui-file-repository',
        label: 'Úložiště souborů',
        icon: 'folder-open',
        parent: null,
        routes: ['file-repository', 'file-repository-folder'],
        privileges: [['openFileRepository', 'useFileRepository'], ['openFileRepository', 'adminFileRepository']],
    },

    // ----------------------------------------------------------------------------------------

    {
        type: 'group',
        name: 'ui-test-group-menu-item',
        label: 'Test',
        icon: 'flask-gear',
        parent: null,
        routes: [],
        privileges: ['#admin'],
    },
    {
        type: 'item',
        name: 'ui-test-api-menu-item',
        label: 'API Test',
        parent: 'ui-test-group-menu-item',
        routes: ['test-page'],
        privileges: ['#admin'],
    },
    {
        type: 'item',
        name: 'ui-test-css-typography-menu-item',
        label: 'CSS Typography',
        parent: 'ui-test-group-menu-item',
        routes: ['test-css-typography'],
        privileges: ['#admin'],
    },
    {
        type: 'item',
        name: 'ui-test-css-grid-menu-item',
        label: 'CSS Grid',
        parent: 'ui-test-group-menu-item',
        routes: ['test-css-grid'],
        privileges: ['#admin'],
    },
    {
        type: 'item',
        name: 'ui-test-css-inputs-menu-item',
        label: 'CSS Inputs',
        parent: 'ui-test-group-menu-item',
        routes: ['test-css-inputs'],
        privileges: ['#admin'],
    },

    // ----------------------------------------------------------------------------------------

    {
        type: 'group',
        name: 'administration-menu-item',
        label: 'Administrace',
        icon: 'folder-gear',
        parent: null,
        routes: [],
    },

];
